export default __webpack_public_path__ + "static/media/feather-users.424897db.svg";